export default {
    expert (state) {
      return state.experts
    },

    selectedExpert (state) {
        return state.selectedExpert
    },

    getExpert: state => (expertId) => {
      return state.experts.find(expert => expert.expertId === expertId)
    },

    interests(state){
        return state.interests
    }
}



// WEBPACK FOOTER //
// ./src/store/modules/experts/getters.js